import api from '../instance'

export function fetchSchooling() {
  return api.get('/schooling')
}
